import type { KeyValue } from './KeyValueList';

type Company = {
  name: string;
  country: string;
  city: string;
  address: string;
  website: string;
  contact: string;
  email: string;
  phone: string;
};

/** The rows every company's information box starts with */
export const contactRows = (c: Company): KeyValue[] => [
  { label: 'Company Name', value: c.name },
  { label: 'Country', value: c.country || '–' },
  { label: 'City', value: c.city || '–' },
  { label: 'Address', value: c.address || '–' },
  { label: 'Website', value: c.website || '–' },
  { label: 'Primary Contact', value: c.contact || '–' },
  { label: 'Email', value: c.email || '–' },
  { label: 'Phone', value: c.phone || '–' },
];
